import { z } from 'zod';
import { ILegalClient } from '../../ILegalClient';
import { GenericLegalTransactionRelationshipMemberSchema } from '../GenericLegalTransactionRelationshipMemberSchema';
import { getEmptyMemberSkeleton } from '../ILegalTransactionRelationshipMember';
import { LegalTransactionRelationshipRoleEnum } from '../LegalTransactionRelationshipRoleEnum';

export const InheritorMemberDataSchema = z.object({
  provisionNotes: z.string(),
});

export type IMemberInheritorData = z.infer<typeof InheritorMemberDataSchema>;

export const InheritorMemberSchema =
  GenericLegalTransactionRelationshipMemberSchema(
    z.literal(LegalTransactionRelationshipRoleEnum.Inheritor),
    InheritorMemberDataSchema
  );

export type IMemberInheritor = z.infer<typeof InheritorMemberSchema>;

export const getEmptyInheritorData = (): IMemberInheritorData => ({
  provisionNotes: '',
});

export function getEmptyInheritorMember(
  legalClient: ILegalClient,
  idRelationship: number
): IMemberInheritor {
  const member: IMemberInheritor = {
    ...getEmptyMemberSkeleton(legalClient, idRelationship),
    idRelationshipRole: LegalTransactionRelationshipRoleEnum.Inheritor,
    data: getEmptyInheritorData(),
  } as IMemberInheritor;

  return member;
}
